import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';
import Hosts from '../../Hosts'
import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../UseToken';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,
	repo_banner_link,

	pattern_vat,
	pattern_email,
	passwordHash,

} from '../../Utils';

import { language } from './Language';
import { color } from "../WEBContent/Color";
import 'react-phone-number-input/style.css'
import { set_language } from '../../Utils';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')

	const [is_edit, set_is_edit] = useState(false)
	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');
	const [entities, setEntities] = useState([]);
	const [responsaveis, setResponsaveis] = useState([]);

	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])

	/////////////////////////////////////////////////////////////////////////////////////////////////////
	const [selectedClienteId, setSelectedClienteId] = useState("Default");
	const [selectedColaboradorId, setSelectedColaboradorId] = useState('');
	const [selectedProjectId, setSelectedProjectId] = useState('');
	const [projetos, setProjetos] = useState([]);
	const [filteredProjects, setFilteredProjects] = useState([]);
	const [prioridade, setPrioridade] = useState('4');
	const [assuntoInput, setAssuntoInput] = useState('');
	//const [solucaoInput, setSolucaoInput] = useState('');
	const [estado, setEstado] = useState(false);
	const [selectedProjectValue, setSelectedProjectValue] = useState("");
	const [solucao, setSolucao] = useState([]); // Array de soluções
	const [descricaoInput, setDescricaoInput] = useState("");
	const [tempoGastoInput, setTempoGastoInput] = useState("");
	const [responsavelInput, setResponsavelInput] = useState("");
	const [projetosPorEntidade, setProjetosPorEntidade] = useState([]);
	const [departamentos, setDepartamentos] = useState([]);
	const [selectedProject, setSelectedProject] = useState(null);
	const [name, setName] = useState(null);
	const [projetoPost, setProjetoPost] = useState([])
	const [tickets, setTickets] = useState([])
	const [dataInicio, setDataInicio] = useState("");
	const [dataFim, setDataFim] = useState("");
	const [tipoProjeto, setTipoProjeto] = useState(null)

	const [tempo, setTempo] = useState(0); // Tempo em segundos
	const [ativo, setAtivo] = useState(false);
	const [tempoFinalizado, setTempoFinalizado] = useState(null);
	const [agrupadasPorAnoEMes, setAgrupadasPorAnoEMes] = useState({});
	const [projetoselecionado, setProjetoSelecionado] = useState(null)
	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				const responseData = res.data[0];
				console.log("Tudo o que vamos buscar", responseData)

				// Check if contacts field is empty and assign a fallback email if necessary
				if (responseData.contacts[0].email === '') {
					responseData.contacts[0].email = responseData.info.email;
				}



				// Update states based on response data structure
				setSelectedClienteId(responseData.info.cliente[0]?.value || selectedClienteId); // Cliente ID
				setSelectedColaboradorId(responseData.info.colaborador[0]?.value || selectedColaboradorId); // Colaborador ID
				setFilteredProjects(responseData.info.projeto[0]?.value || filteredProjects); // Filtered Projects
				setPrioridade(responseData.info.prioridade[0]?.value || prioridade); // Prioridade
				setAssuntoInput(responseData.info.assunto || assuntoInput); // Assunto
				setEstado(responseData.info.estado || estado); // Estado
				setSelectedProjectValue(responseData.info.projeto[0]?.value || selectedProjectValue);
				console.log("Projeto selecionado", selectedProjectValue) // Project Value
				setSolucao(responseData.info.solucao || []);

				console.log("1111111111111111111111", responseData)


				if (responseData.info.projeto?.[0]?.value) {
					setSelectedProjectId(responseData.info.projeto[0].value);

					setTipoProjeto(responseData.info.projeto[0].tipoProjeto || "")
					console.log("ID do projeto:", responseData.info.projeto[0].value);
					console.log("Tipo do projeto", tipoProjeto)

				}
				console.log("dados", dados.current)

				// Set the full response data in _dados
				set_dados(dados.current = responseData);
			})
			.catch(error => {
				alert(error);
				// Optional: Handle fetch failure if needed
			});



	}

	const change_lang = (l) => {
		set_language(l)
		set_lang(l)
		window.location.reload()

		//console.log('language', localStorage.getItem('lang'))
		//console.log('localstorage', localStorage)
	}


	const clean_data = () => {
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)

	}
	const prioridadesTraduzidos = {
		'Normal': {
			value: '1',
			en: 'Normal',
			pt: 'Normal',
		},
		'Urgente': {
			value: '2',
			en: 'Urgent',
			pt: 'Urgente',
		},
		'Crítico': {
			value: '3',
			en: 'Critical',
			pt: 'Crítico',
		},
		'Pouco Urgente': {
			value: '4',
			en: 'Low Priority',
			pt: 'Pouco Urgente',
		},
		'Não Urgente': {
			value: '5',
			en: 'Not Urgent',
			pt: 'Não Urgente',
		}
	};

	// Gerar array com pt e en juntos
	const priorityOptions = Object.values(prioridadesTraduzidos).map(item => ({
		value: item.value,
		labelPt: item.pt,
		labelEn: item.en
	}));


	const traduzir = (valor, traducoes, lang) => {
		if (traducoes[valor]) {
			return traducoes[valor][lang];
		}
		return valor;
	};
	const criarOpcoesPrioridades = (lang) => {
		return Object.keys(prioridadesTraduzidos).map(key => ({
			value: key, // Mantém o valor original (independente da língua)
			label: prioridadesTraduzidos[key][lang], // Tradução baseada no idioma atual
		}));
	};

	// Efeito para atualizar agrupamento sempre que `solucao` mudar
	useEffect(() => {
		const agrupamento = solucao.reduce((agrupadas, solucao) => {
			const data = new Date(solucao.dataAtual);
			const ano = data.getFullYear();
			const mes = data.getMonth() + 1; // Janeiro = 0, então adicionamos 1

			if (!agrupadas[ano]) agrupadas[ano] = {};
			if (!agrupadas[ano][mes]) agrupadas[ano][mes] = [];

			agrupadas[ano][mes].push(solucao);

			return agrupadas;
		}, {});

		setAgrupadasPorAnoEMes(agrupamento);
	}, [solucao]); // Atualiza agrupamento sempre que `solucao` mudar

	useEffect(() => {

		//set_lang('pt')
		//set_lang_id('1')

		//get_fact_legacy_info()
		//get_fact_legacy_info()

		if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
			change_lang('pt')
		}
		else {
			set_lang(localStorage.getItem('lang'))
			console.log("estamos a alterar para", lang)
		}

		setLoading(false)

	}, [props])

	useEffect(() => {

		const fetchData = async () => {
			try {

				const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/`);
				console.log('Entities Data: ', res)

				// responsavel = entidade ===1 
				const responsaveisOptions = res.data
					.filter(entity => entity.entity_type === "1")
					.map(entity => ({
						id: entity.id,
						nome: entity.name,
						departamento: entity.departamento
					}));

				// fetch entidades externas ===2
				const entitiesOptions = res.data
					.filter(entity => entity.entity_type === "2")
					.map(entity => ({
						id: entity.id,
						nome: entity.name
					}));

				setResponsaveis(responsaveisOptions);
				setEntities(entitiesOptions);

				//console.log("Entidades Internas:", responsaveisOptions);
				//console.log("Entidades Externas:", entitiesOptions);

			} catch (error) {
				console.error("Erro ao buscar responsaveis e entidades:", error);
			}

			// Fetch projetos
			try {
				const projetosRes = await reqGET(`${Hosts.SIMCore_API}/intranet/projetos/${getTokenInfo().companycode}`);
				console.log("REQGET DO PROJETO", projetosRes)
				// Filter projects by available date
				const currentDate = new Date();
				const projetosOptions = projetosRes.data
					.filter(projeto => {
						const projectDate = new Date(projeto.info.date[0]?.available);
						return projectDate; // Filter projects with a future available date
					});

				setProjetos(projetosOptions);

				console.log("Projetos:", projetosOptions);

			} catch (error) {
				console.error("Erro ao buscar os projetos:", error);
			}
		};

		fetchData();
	}, []);

	useEffect(() => {
		const fetchDepartamentos = async () => {
			try {
				const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
				const departamentoOptions = res.data.map(departamento => ({
					id: departamento.id,
					name: departamento.info.name,
					software: departamento.info.selectedTypes
				}));
				setDepartamentos(departamentoOptions);
				console.log("Departamentos:", departamentoOptions);
			} catch (error) {
				console.error("Erro ao buscar os departamentos:", error);
			}
		};

		fetchDepartamentos();
	}, []);

	const filterProjetosPorEntidade = (entities, projetos) => {
		if (!entities || !projetos) {
			return [];
		}

		//console.log('Estrutura do projeto:', projetos);

		const projetosPorEntidade = entities.map(entity => {

			const projetosDaEntidade = projetos.filter(projeto => {
				return projeto.info?.empresa == entity.id;  // Usando '==' para comparação flexível
			});

			return {
				entidade: entity,
				projetos: projetosDaEntidade
			};
		});

		return projetosPorEntidade;
	};

	// After entities and projects are loaded, filter and group the projects by entity
	useEffect(() => {

		if (entities.length > 0 && projetos.length > 0) {
			const projetosFiltradosPorEntidade = filterProjetosPorEntidade(entities, projetos);
			setProjetosPorEntidade(projetosFiltradosPorEntidade); // Atualiza o estado com os projetos agrupados por entidade
		}
	}, [entities, projetos]); // Dependências: quando as entidades ou projetos mudam, a filtragem é feita novamente

	// Exemplo de como você pode usar os projetos filtrados
	// O estado 'projetosPorEntidade' agora contém as entidades e seus respectivos projetos filtrados
	useEffect(() => {

		//console.log('Projetos agrupados por entidade:', projetosPorEntidade);
	}, [projetosPorEntidade]);

	useEffect(() => {

		if (selectedProjectId) {
			const foundProject = projetos.find(proj => proj.id === selectedProjectId);
			console.log(foundProject)
			setSelectedProject(foundProject || null); // Update selectedProject with the full project object
		}


	}, [selectedProjectId, projetos])

	useEffect(() => {

		// Obter os dados do localStorage
		const storedData = localStorage.getItem('token');

		if (storedData) {
			// Parse do JSON para um objeto
			const data = JSON.parse(storedData);

			// Verificar a estrutura e imprimir os dados
			if (data.user_info) {
				//console.log('Token:', data.token);

				// Se não estiver aninhado duas vezes
				if (data.user_info.user_info) {
					// Lógica se a estrutura estiver aninhada (não está claro o que fazer aqui)
					//console.log('User info aninhado encontrado.');
				} else {
					//console.log('Profile:', data.user_info.profile);
					//console.log('Id do user logado:', data.user_info.id);

					// Atualiza o estado com os dados do usuário
					//setProfile(data.user_info.profile);
					setName(data.user_info.name);
					//setUserId(data.user_info.id);
					//setLoading(false) // Atualiza o userId

				}
			} else {
				console.log('User info não encontrado no localStorage');
			}
		} else {
			console.log('Dados não encontrados no localStorage');
		}

	}, []);


	///////////////////////////////////Cronometro///////////

	useEffect(() => {

		let intervalo = null;
		if (ativo) {
			intervalo = setInterval(() => {
				setTempo((prevTempo) => prevTempo + 1);
			}, 1000);
		} else if (!ativo && intervalo) {
			clearInterval(intervalo);
		}
		return () => clearInterval(intervalo);
	}, [ativo]);

	const formatarTempo = (segundos) => {
		const minutos = Math.floor(segundos / 60);
		const segundosRestantes = segundos % 60;
		return `${minutos.toString().padStart(2, '0')}:${segundosRestantes.toString().padStart(2, '0')}`;
	};

	const finalizar = () => {
		setAtivo(false);
		const minutosTotais = (tempo / 60).toFixed(2); // Converte para minutos
		setTempoFinalizado(minutosTotais);
	};

	////////////////////////////////////////////////

	useEffect(() => {
		console.log("9")

		clean_data();
		obter_paises_em_pt(set_countries);


		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {


				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {
						obter_distritos_pt(set_districts)
						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)
						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		}
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const calcularCusto = (minutos) => {
		const custoExtra = selectedProject.info.tipoProjeto === 2
			? minutos * 20
			: minutos * 1.20;
		return custoExtra;
	}


	const handle_change_info = ({ target: { name, value } }) => {
		const [field, subField] = name.split('.');

		if (subField) {
			dados.current.info[field] = {
				...dados.current.info[field],
				[subField]: value,
			};
		} else {
			dados.current.info[name] = value;
		}

		set_dados({ ...dados });
	};



	const handleSubmit = async (e) => {
		e.preventDefault();

		const currentDateTime = new Date().toISOString();

		const cliente = entities?.find((empresa) => empresa.id === selectedClienteId) || null;
		const colaborador = responsaveis?.find((resp) => resp.id === selectedColaboradorId) || null;
		const projeto = projetosPorEntidade
			?.find((entity) => entity.entidade.id === selectedClienteId)
			?.projetos.find((proj) => proj.id === selectedProjectId) || null;
		//const projeto = projetos?.find((proj) => proj.id === selectedProjectId) || null;
		const selectedPriority = priorityOptions?.find(option => option.value === prioridade) || null;

		const formData = {
			cliente: cliente ? [{ value: cliente.id, label: cliente.nome }] : [],
			colaborador: colaborador ? [{ value: colaborador.id, label: colaborador.nome }] : [],
			projeto: projeto ? [{ value: projeto.id, label: projeto.info?.nome[0]?.nomeCompleto || 'Nome do Projeto Não Disponível' }] : [],
			//projeto: projeto ? [{ value: projeto.id, label: projeto.name }] : [],
			prioridade: selectedPriority ? [selectedPriority] : [],
			assunto: assuntoInput,
			//solucao: solucaoInput,
			data: currentDateTime,
			solucao,
			estado: estado
		};


		const atualizaProjetos = await reqPUT('https://sede.assec.pt/api/simnet_genuine_website/intranet/projetos/', projetoPost);
		console.log("Projeto atualizado", atualizaProjetos)
		console.log("SOLUCAOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO", formData)
		//console.log("id do cliente", dados.current.info.cliente)
		//setSelectedClienteId(dados.current.info.cliente || dados.current.info?.cliente[0].value);
		//setSelectedColaboradorId(dados.current.info.colaborador || dados.current.info?.colaborador[0].value);
		//setFilteredProjects(dados.current.info.projeto[0].value);
		//setPrioridade(dados.current.info.prioridade[0].value);
		//setFilteredProjects(dados.current.info.projeto);
		//setPrioridade(dados.current.info.prioridade || dados.current.info.prioridade[0].value);
		//setAssuntoInput(dados.current.info.assunto);
		//setEstado(dados.current.info.estado);
		//setSolucaoInput(dados.current.info.solucao);

		if (is_edit) {
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: color.corPrimaria.rgb,
				cancelButtonColor: color.corVermelha.rgb,
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel,
			}).then((result) => {
				if (result.isConfirmed) {
					if (is_password) {
						const password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					/* if (solucaoInput !== '') {
						dados.current.info.estado = true;
					} */

					dados.current.info = { ...dados.current.info, ...formData };

					reqPUT(api_crud_route, dados.current)
						.then(() => {
							set_new_password('');
							set_confirm_password('');
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'));
				}
			});
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: color.corPrimaria.rgb,
				cancelButtonColor: color.corVermelha.rgb,
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel,
			}).then((result) => {
				if (result.isConfirmed) {
					if (is_password) {
						const password = new_password;
						dados.current.info.password = passwordHash(password);
					}

					dados.current.info = { ...dados.current.info, ...formData };

					reqPOST(api_crud_route, dados.current)
						.then(() => {
							console.log("Entrou no post")
							set_new_password('');
							set_confirm_password('');
							props.history.push(endpoints.list);
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'));
				}
			});
		}
		console.log("fora do else", dados.current.info)
	};


	// CASO SEJA PRECISO ADICIONAR SOLUÇÕES NOUTRA DATA PARA TESTE
	const adicionarSolucaoNoutroMes = () => {
		const novaSolucao = {
			id: new Date().getTime().toString(), // ID único
			descricao: "Solução de Teste ",
			tempoGasto: 120, // Exemplo: 2 horas
			dataAtual: new Date(2025, 5, 15).toISOString(),
			responsavel: "Zé ",
		};

		setSolucao((prevSolucoes) => [...prevSolucoes, novaSolucao]);
	};

	const addSolucao = () => {
		const currentDate = new Date();
		const currentMonth = currentDate.getMonth() + 1; // Get current month (1-12)
		const currentYear = new Date().getFullYear();

		if (!dataInicio || !dataFim) {
			alert("Por favor, selecione as datas de início e fim.");
			return;
		}

		// Converter as datas para objetos Date
		const inicio = new Date(dataInicio);
		const fim = new Date(dataFim);

		// Verificar se as datas são válidas e se a data de início é antes da data de fim
		if (inicio >= fim) {
			alert("A data de início deve ser anterior à data de fim.");
			return;
		}

		// Calcular a diferença em minutos
		const diferencaMs = fim - inicio;
		const diferencaMinutos = Math.floor(diferencaMs / 1000 / 60);

		//console.log("MINUTOSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS", diferencaMinutos)

		const novaSolucao = {
			id: new Date().getTime().toString(), // Unique ID based on timestamp
			descricao: descricaoInput,
			//tempoGasto: diferencaMinutos,
			tempoGasto: diferencaMinutos,
			dataAtual: currentDate.toISOString(),
			responsavel: name,
			//responsavel: responsavelInput ? [responsavelInput] : [],
			custo: 0
		};

		setSolucao(prevSolucoes => [...prevSolucoes, novaSolucao]);


		setProjetos(prevProjetos => {
			if (!prevProjetos) return [];  // Se não houver projetos, retornar um array vazio

			return prevProjetos.map(projeto => {
				// Garantir que assistenciaMensal está presente e é um array
				if (!projeto.info?.assistenciaMensal || !Array.isArray(projeto.info.assistenciaMensal)) {
					console.log('AssistenciaMensal não está presente ou não é um array. Inicializando como array vazio para o projeto:', projeto);
					projeto.info.assistenciaMensal = []; // Inicializando como array vazio
				}
				if (projeto.id !== selectedProjectId) {
					return projeto; // Skip if this is not the project we want to update
				}

				// Atualizar assistenciaMensal para o projeto
				const updatedAssistenciaMensal = projeto.info.assistenciaMensal.map(assistencia => {
					if (assistencia.ano === currentYear && assistencia.mes === currentMonth) {



						let minutosRestantes = assistencia.minutosRestantes;

						if (minutosRestantes !== undefined && minutosRestantes !== null) {
							// Tente converter o valor para número, tanto se for string quanto número
							//minutosRestantes = parseInt(assistencia.minutosRestantes, 10)
							minutosRestantes = Number(minutosRestantes);
							//console.log("Minutos restantes", minutosRestantes)
						}



						// Subtrair tempoGasto de minutosRestantes, garantindo que não fique abaixo de zero
						const newMinutosRestantes = Math.max(minutosRestantes - diferencaMinutos);

						if (newMinutosRestantes < 0) {
							const minutosExtras = Math.abs(newMinutosRestantes); // Minutos que excederam o tempo de assistência
							console.log(`Minutos extras utilizados: ${minutosExtras}`);
							calcularCusto(minutosExtras)
							minutosRestantes = 0;
						} else {
							minutosRestantes = newMinutosRestantes;
						}

						return {
							...assistencia,
							minutosRestantes: newMinutosRestantes
						};
					}

					return assistencia;  // Caso o mês não seja o correto, retornar a assistência sem alterações
				});
				//const ticketid= tickets.push(dados.current.id)
				console.log("Id do ticket que vai ser criado", dados.current.id)
				// Atualizando o projeto com a assistenciaMensal modificada
				/* const updatedProjeto = {
					...projeto,
					info: {
						...projeto.info,
						assistenciaMensal: updatedAssistenciaMensal,
						tickets: dados.current.id || []  // Substituindo assistenciaMensal com os valores atualizados
					}
				}; */
				const updatedProjeto = {
					...projeto,
					info: {
						...projeto.info,
						assistenciaMensal: projeto.info.assistenciaMensal.map((item, index) => {
							if (index === 0) { // Exemplo: Atualiza apenas o índice desejado
								return {
									...item,
									tickets: item.tickets.includes(dados.current.id)
										? item.tickets // Se já existir, mantém o array original
										: [...item.tickets, dados.current.id], // Se não existir, adiciona o novo ID
								};
							}
							return item; // Não modifica os outros itens do array
						}),
						tickets: dados.current.id || [] // Atualiza tickets no nível principal, se necessário
					}
				};



				console.log('Projeto atualizado:', updatedProjeto);
				setProjetoPost(updatedProjeto)
				return updatedProjeto;
			});
		});

		//setDescricaoInput("");
		//setTempoGastoInput("");

		setDataFim("")
		setDataInicio("")
		setTempo("")
		setDescricaoInput("")
	};

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: color.corPrimaria.rgb,
			cancelButtonColor: color.corVermelha.rgb,
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">
						{dados.current.id !== '' && dados.info && dados.info.name
							? `${language[lang].entity} - ${dados.info.name}`
							: language[lang].entity
						}
					</h2>
					<p>
						{dados.current.id !== ''
							? language[lang].entity_edit
							: language[lang].entity_new
						}
					</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0" />
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>
											<div className="card-body border-top p-4">
												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].cliente}</label>
														<select
															name="cliente"
															className="form-control form-control-lg mt-1 mb-5 mb-lg-0 rounded-2"
															value={selectedClienteId || dados.current.info?.cliente[0].value || ''}
															onChange={(e) => setSelectedClienteId(e.target.value)}
															disabled={is_edit}
															required
														>
															<option value="Default">{language[lang].cliente_placeholder}</option>
															{entities.map((empresa) => (
																<option key={empresa.id} value={empresa.id}>
																	{empresa.nome}
																</option>
															))}
														</select>
													</div>
												</div>

												<div className="row mb-2">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].projeto}</label>
														<select
															className="form-control form-control-lg mt-1 mb-5 mb-lg-0 rounded-2"
															value={selectedProjectId || ''}
															onChange={(e) => setSelectedProjectId(e.target.value)}
															disabled={!selectedClienteId || is_edit}
															required
														>
															<option value="Default">{language[lang].projeto_placeholder}</option>
															{projetosPorEntidade.map((entity) =>
																entity.entidade.id === selectedClienteId && entity.projetos.length > 0
																	? entity.projetos.map((projeto) => (
																		<option key={projeto.id} value={projeto.id}>
																			{projeto.info?.nome[0]?.nomeCompleto || language[lang].no_projeto}
																		</option>
																	))
																	: null
															)}
														</select>
													</div>

													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].prioridade}</label>
														<div className="d-flex flex-column">
															{priorityOptions.map(({ value, labelPt, labelEn }) => (
																<label key={value} className="d-flex align-items-center mb-1">
																	<input
																		type="radio"
																		value={value}
																		checked={prioridade === value}
																		onChange={(e) => setPrioridade(e.target.value)}
																		style={{ marginRight: '10px' }}
																		disabled={is_edit}
																	/>
																	{lang === 'en' ? labelEn : labelPt}
																</label>
															))}
														</div>
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].respons}</label>
														<select
															name="responsavel"
															className="form-control form-control-lg mt-1 mb-4 mb-lg-0 rounded-2"
															value={String(selectedColaboradorId || dados.current.info?.colaborador || '')}
															onChange={(e) => setSelectedColaboradorId(e.target.value)}
															disabled={!selectedProjectId || is_edit}
															required
														>
															<option value="">{language[lang].responsavel_placeholder}</option>
															{responsaveis
																.filter((resp) => {
																	const selectedProjeto = projetosPorEntidade
																		.find((entity) => entity.entidade.id === selectedClienteId)
																		?.projetos.find((projeto) => projeto.id === selectedProjectId);

																	if (selectedProjeto) {
																		const nomeCompletoFirstPart = selectedProjeto.info?.nome[0]?.nomeCompleto?.split(' ')[0];

																		if (resp.departamento) {
																			return resp.departamento.some((el) =>
																				true && el.software?.some((sw) => sw.nome === nomeCompletoFirstPart)
																			);
																		}
																	}
																	return false;
																})
																.map((resp) => (
																	<option key={resp.id} value={resp.id}>
																		{resp.nome}
																	</option>
																))}
														</select>
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].assunto}</label>
														<textarea
															value={assuntoInput}
															onChange={(e) => setAssuntoInput(e.target.value)}
															className="form-control mt-2"
															disabled={is_edit}
															rows={5}
														/>
													</div>

													{(getTokenInfo().profile === 'Administrador' || getTokenInfo().profile === 'TeamLeader') && (
														<div className="col-md-6 d-flex align-items-center">
															<div className="form-check">
																<label className="form-check-label ms-2" htmlFor="estadoCheckbox">
																	{language[lang].ticket_finish}
																</label>
																<input
																	className="form-check-input"
																	type="checkbox"
																	id="estadoCheckbox"
																	checked={estado}
																	onChange={(e) => setEstado(e.target.checked)}
																/>
															</div>
														</div>
													)}
												</div>

												<div className="row mb-5">
													{/*
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].respons}</label>
														<select
															name="responsavel"
															className="form-control form-control-lg mt-1 mb-6 mb-lg-0 rounded-2"
															value={String(selectedColaboradorId || dados.current.info?.colaborador || '')}
															onChange={(e) => setSelectedColaboradorId(e.target.value)}
															disabled={is_edit}
															required
														>
															<option value="">{language[lang].responsavel_placeholder}</option>
															{responsaveis
																.filter((resp) => {
																	const selectedProjeto = projetosPorEntidade
																		.find((entity) => entity.entidade.id === selectedClienteId)
																		?.projetos.find((projeto) => projeto.id === selectedProjectId);

																	console.log('Responsavel:', resp);

																	if (selectedProjeto) {
																		const nomeCompletoFirstPart = selectedProjeto.info?.nome[0]?.nomeCompleto?.split(' ')[0];

																		console.log('Tipo de Projeto:', nomeCompletoFirstPart);
																		console.log('Responsavel Software:', resp);

																		if (resp.departamento != null){
																			return resp.departamento.filter(el => el.id === '28').pop()?.software?.some((sw) => sw.nome === nomeCompletoFirstPart);
																		}

																		return [];
																	}
																	return false;
																})
																.map((resp) => (
																	<option key={resp.id} value={resp.id}>
																		{resp.nome}
																	</option>
																))}
															{console.log('Projetos por Responsavel:', responsaveis)}
														</select>														
													</div>
													*/}
												</div>
												{/* 	{is_edit && (
													<div className="row mb-5">
														<div className="col-md-6">
															<label className="fs-5 fw-bold mb-2">{language[lang].solucao}</label>
															<textarea
																value={solucaoInput}
																onChange={(e) => setSolucaoInput(e.target.value)}
																className="form-control mt-2"
																rows={5}
															/>
														</div>
													</div>
												)} */}
												<div>
													{is_edit && (
														<div className="row mb-5">
															<div className="col-md-6">
																<label className="fs-5 fw-bold mb-2">{language[lang].solucao}</label>
																{/* Campo para Descrição */}
																<textarea
																	value={descricaoInput}
																	onChange={(e) => setDescricaoInput(e.target.value)}
																	className="form-control mt-2"
																	placeholder="Descrição"
																	rows={3}
																/>
																{/* Campo para Data e Hora de Início */}
																<label className="form-label mt-3">{language[lang].data_inicio}</label>
																<input
																	type="datetime-local"
																	value={dataInicio}
																	onChange={(e) => setDataInicio(e.target.value)}
																	className="form-control"
																/>

																{/* Campo para Data e Hora de Fim */}
																<label className="form-label mt-3">{language[lang].data_fim}</label>
																<input
																	type="datetime-local"
																	value={dataFim}
																	onChange={(e) => setDataFim(e.target.value)}
																	className="form-control"
																/>


																{/* 	<h1>Inciar Assistencia</h1>
																<h2>{formatarTempo(tempo)}</h2>
																<div>
																	<button type="button" onClick={() => setAtivo(!ativo)}>
																		{ativo ? 'Pausar' : 'Iniciar'}
																	</button>
																	<button type="button" onClick={finalizar} disabled={!ativo}>
																		Finalizar Assistencia
																	</button>
																</div>
																{tempoFinalizado && (
																	<div>
																		<h3>Tempo gasto: {tempoFinalizado} minutos</h3>
																	</div>
																)}
																 */}



																{/* Campo para Tempo Gasto */}
																{/* 	<input
																	type="text"
																	value={tempoGastoInput}
																	onChange={(e) => setTempoGastoInput(e.target.value)}
																	className="form-control mt-2"
																	placeholder="Tempo Gasto (em minutos)"
																/> */}

																{/* Campo para Responsável */}
																{/* <input
																	type="text"
																	value={responsavelInput}
																	onChange={(e) => setResponsavelInput(e.target.value)}
																	className="form-control mt-2"
																	placeholder="Responsável"
																/> */}

																{/* Botão para adicionar a nova solução */}
																<button onClick={addSolucao} className="btn btn-primary mt-3">
																	{language[lang].add_solution}
																</button>

																<br />

																<label className="fs-5 fw-bold mb-2" style={{ marginTop: '10%' }}>
																	{language[lang].total}
																	<br />
																	<span style={{ fontWeight: 'normal' }}>
																		{solucao.reduce((total, item) => total + Number(item.tempoGasto), 0)} {language[lang].minutes} / {" "}
																		{(
																			solucao.reduce((total, item) => total + Number(item.tempoGasto), 0) / 60
																		).toFixed(2)} {language[lang].hours}
																	</span>
																</label>

																<br />

																{/* CASO SEJA PRECISO ADICIONAR SOLUÇÕES NOUTRO MES PARA TESTAR */}
																<button type="button" onClick={adicionarSolucaoNoutroMes} className="btn btn-primary">
																	{language[lang].add_test_solution}
																</button>
															</div>

															{/* Lista de Soluções Adicionadas */}
															<div className="col-md-6">
																<label className="fs-5 fw-bold mb-2">{language[lang].solucao_adicionadas}</label>
																{solucao.length === 0 ? (
																	<p>{language[lang].no_solution}</p>
																) : (
																	solucao.map((item, index) => (
																		<div key={item.id} className="border p-4 mb-4">
																			<p><strong>{language[lang].description}:</strong> {item.descricao}</p>
																			<p><strong>{language[lang].time_spent}:</strong> {item.tempoGasto} {language[lang].minutes}</p>
																			<p><strong>{language[lang].table_date}:</strong> {new Date(item.dataAtual).toLocaleString()}</p>
																			<p> <strong>{language[lang].responsavel}: </strong> {item.responsavel}</p>
																		</div>
																	))
																)}
															</div>
														</div>
													)}
													<div>

														<div className="container mt-4">
															<div className="accordion" id="accordionSolucoes">
																{Object.keys(agrupadasPorAnoEMes).map((ano, indexAno) => (
																	<div className="accordion-item" key={ano}>
																		<h2 className="accordion-header" id={`heading-${ano}`}>
																			<button
																				className="accordion-button"
																				type="button"
																				data-bs-toggle="collapse"
																				data-bs-target={`#collapse-${ano}`}
																				aria-expanded="true"
																				aria-controls={`collapse-${ano}`}
																			>
																				{ano}
																			</button>
																		</h2>
																		<div
																			id={`collapse-${ano}`}
																			className={`accordion-collapse collapse ${indexAno === 0 ? "show" : ""}`}
																			aria-labelledby={`heading-${ano}`}
																			data-bs-parent="#accordionSolucoes"
																		>
																			<div className="accordion-body">
																				{Object.keys(agrupadasPorAnoEMes[ano]).map((mes) => {
																					// Calcular o total de tempo gasto no mês (em minutos)
																					const totalTempoGasto = agrupadasPorAnoEMes[ano][mes].reduce(
																						(total, solucao) => total + solucao.tempoGasto,
																						0
																					);
																					// Converter para horas
																					const totalHoras = (totalTempoGasto / 60).toFixed(2); // Duas casas decimais

																					return (
																						<div key={mes} className="mb-3">
																							<h5>
																								{
																									[
																										"Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
																										"Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
																									][mes - 1]
																								}
																							</h5>
																							<p>
																								<strong>{language[lang].total_time_spent}:</strong> {totalHoras} {language[lang].hours}
																							</p>
																							<ul>
																								{agrupadasPorAnoEMes[ano][mes].map((solucao) => (
																									<li key={solucao.id}>
																										<strong>{language[lang].description}:</strong> {solucao.descricao} |{" "}
																										<strong>{language[lang].time}:</strong> {solucao.tempoGasto} {language[lang].minutes}
																									</li>
																								))}
																							</ul>
																						</div>
																					);
																				})}
																			</div>
																		</div>
																	</div>
																))}
															</div>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div >

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
